import React, { useState, useEffect } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingButton from "../LoadingButton/LoadingButton";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import "./ResetPassword.css";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setMessage("Geçersiz veya eksik şifre sıfırlama bağlantısı.");
      setIsError(true);
    }
  }, [token]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage("Şifreler eşleşmiyor.");
      setIsError(true);
      return;
    }
    setIsLoading(true);
    setMessage("");
    try {
      const response = await fetch("https://alternative-lamprey-fatma-celik-a9c7fc96.koyeb.app/api/reset-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      const data = await response.json();
      if (data.success) {
        setMessage(
          "Şifreniz başarıyla güncellendi. Giriş sayfasına yönlendiriliyorsunuz..."
        );
        setIsError(false);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setMessage(data.error || "Bir hata oluştu.");
        setIsError(true);
      }
    } catch (err) {
      setMessage("Sunucu hatası. Lütfen daha sonra tekrar deneyin.");
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <OrbitLoaderComponent size="medium" showPath={true} />
        <p className="loading-text">İşleniyor...</p>
      </div>
    );
  }

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <div className="reset-password-form">
          <h2>Şifre Sıfırlama</h2>
          {message && (
            <div className={`message ${isError ? "error" : "success"}`}>
              {message}
            </div>
          )}
          <form onSubmit={handleResetPassword}>
            <div className="form-group">
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Yeni Şifre"
                  className="form-input"
                  required
                />
                <Lock className="input-icon" />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="password-toggle"
                  aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                >
                  {showPassword ? (
                    <EyeOff className="w-5 h-5" />
                  ) : (
                    <Eye className="w-5 h-5" />
                  )}
                </button>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Yeni Şifre (Tekrar)"
                  className="form-input"
                  required
                />
                <Lock className="input-icon" />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="password-toggle"
                  aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                >
                  {showPassword ? (
                    <EyeOff className="w-5 h-5" />
                  ) : (
                    <Eye className="w-5 h-5" />
                  )}
                </button>
              </div>
            </div>
            <LoadingButton
              type="submit"
              isLoading={isLoading}
              className="reset-button"
            >
              {isLoading ? "İşleniyor..." : "Şifremi Sıfırla"}
            </LoadingButton>
          </form>
          <button className="back-button" onClick={() => navigate("/login")}>
            Giriş Sayfasına Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
